// extracted by mini-css-extract-plugin
export var productImage = "_ow-1";
export var viewLink = "_ow-2";
export var wishlistItem = "_ow-0";